<div class="container-fluid p-2">
 <form [formGroup]="myForm">
  <div class="row mb-4">
    <div class="col-6">
      <button type="button" class="btn btn-primary" (click)="goBack()">Back</button>
    </div>
  </div>
  <div>
    <div class="row text-center fs-4"> Please update or create new one</div>
    <mat-radio-group class="mb-4" #nextstp 
    (change)="onNextStep($event)" 
    formControlName="removetype">
      <div class="container-fluid p-2 mb-4">
      <div class="row text-center"> Update {{dbService.selectedEvent.title}}</div>
  
      <div class="row">
        <mat-radio-button color="primary" value="adjustdatetime">
          Adjust Dates (Current: {{dbService.selectedEvent.fromdate | date:'short'}} to {{dbService.selectedEvent.todate | date:'short'}})
        </mat-radio-button>
      </div>
      <div class="row">
        <mat-radio-button color="primary"  value="addattendees">
          Add or Remove Attendees
        </mat-radio-button>
      </div>
      @if(dbService.uploadStagingMap.size > 0) {
      <div class="row">
        <mat-radio-button color="primary" value="publish">
          Review Uploads and Publish
        </mat-radio-button>
      </div>
      }
      <div class="row">
      <mat-radio-button color="primary"  value="deleteevent">
        Delete Event and All Uploads
      </mat-radio-button>
      </div>
      @if(this.dbService.dataSource.data.length > 0){
        <div class="row">
          <mat-radio-button color="primary" value="showuploads">
            Show Uploads
          </mat-radio-button>
        </div>
      }
      <div class="row text-center"> I want to Create new event </div>
      <div class="row mb-4">
      <mat-radio-button color="primary"  value="createevent">
          Create Event
      </mat-radio-button>
      </div>
      <!--div class="row text-center"> I want to remove expired router links </div>
      <div class="row mb-4">
      <mat-radio-button color="primary"  value="deletexpiredroutelinks">
          Remove expired links
      </mat-radio-button>
      </div-->
    </div>
  </mat-radio-group>
   
</div>
<div class="row">
   @if(showNextStep){
      <div class="col-6">
        <button type="button" class="btn btn-primary mb-4" (click)="onContinue()">Continue</button>
      </div>
    }
    @if(showUploads){
      <div class="col-6">
        <button type="button" class="btn btn-primary" (click)="onShowUploads()">Hide Uploads</button>
      </div>
    }
  

@if(showUploads){
  <div class="container">
    <app-show-uploads></app-show-uploads>
  </div>
}

</div>
<ng-template #successfullyDelete>
  <div class="container">
  <h2 mat-dialog-title>Success</h2>
  <mat-dialog-content>
    <p>Successfully Deleted {{title}} Event.</p>
    </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
  </div>
</ng-template>
<ng-template #successfullyComplete>
  <div class="container">
  <h2 mat-dialog-title>Success</h2>
  <mat-dialog-content>
    <div class="row">Successfully Created {{title}} Event & Attendees invited.</div>
    <div class="row">You may close the browser.</div>
    </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
  </div>
</ng-template>
</form>
</div>